import * as React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './Toast.module.css';

interface ToastState {
  visible: boolean;
  message: string;
}

let globalSetToast: ((state: ToastState) => void) | null = null;

let hideTimer: ReturnType<typeof setTimeout> | null = null;

export function showToast(message: string) {
  if (hideTimer) {
    clearTimeout(hideTimer);
  }
  globalSetToast?.({ visible: true, message });
  hideTimer = setTimeout(() => {
    globalSetToast?.({ visible: false, message: '' });
  }, 2000);
}

export function ToastContainer() {
  const [toast, setToast] = React.useState<ToastState>({ visible: false, message: '' });

  React.useEffect(() => {
    globalSetToast = setToast;
    return () => {
      if (globalSetToast === setToast) {
        globalSetToast = null;
      }
    };
  }, []);

  return (
    <AnimatePresence>
      {toast.visible && (
        <motion.div
          className={styles.container}
          role="status"
          aria-live="polite"
          aria-atomic="true"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 8 }}
          transition={{ duration: 0.2, ease: [0.2, 0.8, 0.2, 1] }}
        >
          {toast.message}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
